import { TFunction } from "i18next";
import pick from "lodash/pick";
import * as queryString from "query-string";
import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";

import { PermissionScope } from "@/modules/auth";
import { EMAIL_PARAM_NAME } from "../../hooks/useEmailParam";
import { TAX_YEAR_PARAM_NAME } from "../../pages/TaxDeclaration/hooks/useTaxYearParam";

export interface NavigationLink {
  icon?: React.ComponentType;
  path?: string;
  label: string;
  preserveQueryParams?: boolean;
  onClick?: () => void;
  requiredScope?: PermissionScope[];
  featureFlag?: string;
}

export interface LeftNavItemProps {
  item: NavigationLink;
}

const getTexts = (t: TFunction<"Navigation", undefined>) => ({
  label: (labelName: string) => t(`navigation.${labelName}`, ""),
});

const QUERY_PARAMS_TO_PRESERVE = [EMAIL_PARAM_NAME, TAX_YEAR_PARAM_NAME];
const getQueryParamsToPreserve = (search: string) => {
  const allParams = queryString.parse(search);
  const paramsToPreserve = pick(allParams, QUERY_PARAMS_TO_PRESERVE);
  return queryString.stringify(paramsToPreserve);
};

const LeftNavItem = ({ item }: LeftNavItemProps) => {
  const location = useLocation();
  const { t } = useTranslation("Navigation");
  const texts = getTexts(t);

  return (
    <NavLink
      onClick={item.onClick}
      to={{
        pathname: item.path,
        search: item.preserveQueryParams
          ? getQueryParamsToPreserve(location.search)
          : undefined,
      }}
    >
      {texts.label(item.label) || item.label}
    </NavLink>
  );
};

export default LeftNavItem;
